import { render } from "./ReportTab.vue?vue&type=template&id=e5a17a00&scoped=true"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"

import "./ReportTab.vue?vue&type=style&index=0&id=e5a17a00&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a17a00"]])

export default __exports__